import React, { use, useState } from "react";
import ModalCalendarWeek from "../../../../components/elements/ModalCalendarWeek";
import ModalSpecificHours from "../../../../components/elements/ModalSpecificHours";
import ModalSeasonalHours from "../../../../components/elements/ModalSeasonalHours";
import ModalDisabledDays from "../../../../components/elements/ModalDisabledDays";
import { message } from "antd";
import { Pencil, X, Clock, Calendar, User, AlertCircle } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import ModalCitasConfig from "../../../../components/elements/ModalCitasConfig";
import {
  setTiempoCitas,
  setDuracionCitas,
  setMaximoCitas,
  setMaximoTiempoAnticipacion,
} from "../../../../slices/calendarSlice";
import { useNavigate } from "react-router-dom"

const secondaryNavigation = [
  { name: 'Cuenta', href: '/admin/settings', current: false },
  { name: 'Notificaciones', href: '/admin/notifications', current: false },
  { name: 'Calendario', href: '/admin/calendly', current: true },
  { name: 'Equipos', href: '#', current: false },
  { name: 'Integraciones', href: '#', current: false },
]

export default function CalendarApo() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSpecificHoursModalOpen, setIsSpecificHoursModalOpen] = useState(false);
  const [isSeasonalHoursModalOpen, setIsSeasonalHoursModalOpen] = useState(false);
  const [isDisabledDaysModalOpen, setIsDisabledDaysModalOpen] = useState(false); 
  const { weeklyHoursRedux, disabledDaysRedux } = useSelector((state) => state.calendar);
  const [isCitasModalOpen, setIsCitasModalOpen] = useState(false);
  
  const dispatch = useDispatch()

  const {
    tiempoCitas,
    duracionCitas,
    maximoCitas,
    maximoTiempoAnticipacion,
  } = useSelector((state) => state.calendar);

  const [weeklyHours, setWeeklyHours] = useState({
    lun: [{ start: "09:00", end: "17:00" }],
    mar: [{ start: "09:00", end: "17:00" }],
    mie: [{ start: "09:00", end: "17:00" }],
    jue: [{ start: "09:00", end: "17:00" }],
    vie: [{ start: "09:00", end: "17:00" }],
    sab: [{ start: "09:00", end: "13:15" }],
    dom: [], 
  });

  

  const [specificHours, setSpecificHours] = useState([]);
  const [seasonalHours, setSeasonalHours] = useState([]);
  const [disabledDays, setDisabledDays] = useState([]);
  const [editingSeasonIndex, setEditingSeasonIndex] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();

  const [editingSpecificHourIndex, setEditingSpecificHourIndex] = useState(null);

  const navigate = useNavigate()

  const handleEditSpecificHour = (index) => {
    setIsSpecificHoursModalOpen(true);
    setEditingSpecificHourIndex(index);
  };
  
  const handleDeleteSpecificHour = (index) => {
    const updatedSpecificHours = specificHours.filter((_, i) => i !== index);
    setSpecificHours(updatedSpecificHours);
  };

  const errorMessage = () => {
    messageApi.open({
      type: "error",
      content: "No se pueden guardar horarios en dias desabilitados",
    });
  };

  const errorMessageOverLap = () => {
    messageApi.open({
      type: "error",
      content: "No se pueden superponer los horarios.",
    });
  }

  const handleSave = (newSchedule) => {
    setWeeklyHours(newSchedule);
    //dispatch(updateWeeklyHours(newSchedule));
    setIsModalOpen(false);
  };

  const handleSaveSpecificHours = (date, timeBlocks) => {
    if (editingSpecificHourIndex !== null) {
     
      const updatedSpecificHours = [...specificHours];
      updatedSpecificHours[editingSpecificHourIndex] = { date, timeBlocks };
      setSpecificHours(updatedSpecificHours);
      setEditingSpecificHourIndex(null);
    } else {
      
      setSpecificHours([...specificHours, { date, timeBlocks }]);
    }
  };

  const handleSaveSeasonalHours = ({ seasonName, startDate, endDate, schedule }) => {
    if (editingSeasonIndex !== null) {
      const updatedSeasonalHours = [...seasonalHours];
      updatedSeasonalHours[editingSeasonIndex] = { seasonName, startDate, endDate, schedule };
      setSeasonalHours(updatedSeasonalHours);
      setEditingSeasonIndex(null);
    } else {
      setSeasonalHours([...seasonalHours, { seasonName, startDate, endDate, schedule }]);
    }
    setIsSeasonalHoursModalOpen(false);
  };

  const handleSaveDisabledDays = (days) => {
    setDisabledDays(days);
    
    setIsDisabledDaysModalOpen(false);
  };

  const handleEditSeason = (index) => {
    setEditingSeasonIndex(index);
    setIsSeasonalHoursModalOpen(true);
  };

  const handleDeleteSeason = (index) => {
    const updatedSeasonalHours = seasonalHours.filter((_, i) => i !== index);
    setSeasonalHours(updatedSeasonalHours);
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("es-ES", {
      timeZone: "UTC",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div className=" md:p-4 bg-background  ">
      {contextHolder}
      <header className="border-b border-gray-200 mb-8">
          {/* Navegación secundaria */}
          <nav className="flex py-4">
            <ul
              
              className="flex sm:w-full w-[200px]  flex-none sm:gap-x-6 gap-x-3 sm:px-4 text-sm font-semibold text-text  lg:px-8"
            >
              {secondaryNavigation.map((item) => (
                <li className='text-xs sm:text-base' key={item.name}>
                  <button onClick={() => navigate(`${item.href}`) } className={item.current ? 'text-indigo-600' : ''}>
                    {item.name}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </header>
      <h1 className="text-2xl md:text-3xl font-bold text-text mb-6 md:mb-6 font-poppina ">Administrador de Horarios</h1>

      <div className="p-4 md:p-8 bg-background font-poppina">
  {/* Botón para abrir el modal */}
  <button
    onClick={() => setIsCitasModalOpen(true)}
    className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors mb-6"
  >
    Configurar Citas
  </button>

  {/* Sección para mostrar las cards con los datos */}
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
    {/* Card para Tiempo de cita */}
    <div className="bg-background p-6 rounded-lg shadow-md border border-border hover:shadow-lg transition-shadow">
      <div className="flex items-center gap-3 mb-4">
        <Clock className="w-6 h-6 text-blue-500" />
        <h3 className="text-lg font-semibold text-text">Tiempo de cita</h3>
      </div>
      <p className="text-text text-sm">
        {tiempoCitas ? `${tiempoCitas} minutos` : "No configurado"}
      </p>
    </div>

    {/* Card para Tiempo entre citas */}
    <div className="bg-background p-6 rounded-lg shadow-md border border-border hover:shadow-lg transition-shadow">
      <div className="flex items-center gap-3 mb-4">
        <Clock className="w-6 h-6 text-green-500" />
        <h3 className="text-lg font-semibold text-text">Tiempo entre citas</h3>
      </div>
      <p className="text-text text-sm">
        {duracionCitas ? `${duracionCitas} minutos` : "No configurado"}
      </p>
    </div>

    {/* Card para Máximo de citas por día */}
    <div className="bg-background p-6 rounded-lg shadow-md border border-border hover:shadow-lg transition-shadow">
      <div className="flex items-center gap-3 mb-4">
        <User className="w-6 h-6 text-purple-500" />
        <h3 className="text-lg font-semibold text-text">Máximo de citas por día</h3>
      </div>
      <p className="text-text text-sm">
        {maximoCitas || "No configurado"}
      </p>
    </div>

    {/* Card para Máximo de tiempo de anticipación */}
    <div className="bg-background p-6 rounded-lg shadow-md border border-border hover:shadow-lg transition-shadow">
      <div className="flex items-center gap-3 mb-4">
        <AlertCircle className="w-6 h-6 text-orange-500" />
        <h3 className="text-lg font-semibold text-text">Máximo de tiempo de anticipación</h3>
      </div>
      <p className="text-text text-sm">
        {maximoTiempoAnticipacion ? `${maximoTiempoAnticipacion} días` : "No configurado"}
      </p>
    </div>
  </div>

  <ModalCitasConfig
    isModalOpen={isCitasModalOpen}
    setIsModalOpen={setIsCitasModalOpen}
    tiempoCitas={tiempoCitas}
    setTiempoCitas={(value) => dispatch(setTiempoCitas(value)) }
    duracionCitas={duracionCitas}
    setDuracionCitas={(value) => dispatch(setDuracionCitas(value))}
    maximoCitas={maximoCitas}
    setMaximoCitas={(value) => dispatch(setMaximoCitas(value)) }
    maximoTiempoAnticipacion={maximoTiempoAnticipacion}
    setMaximoTiempoAnticipacion={(value) => dispatch(setMaximoTiempoAnticipacion(value)) }
  />
</div>

      <div className="flex flex-col lg:flex-row gap-6">
        <section className="bg-background p-4 md:p-6 rounded-lg shadow-md flex-1">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg md:text-xl font-semibold text-subtitle">Horas semanales</h2>
            <button onClick={() => setIsModalOpen(true)} className="text-blue-500 hover:text-blue-700">
              Editar horas semanales
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 text-left">
              <tbody>
                {Object.entries(weeklyHours).map(([day, timeBlocks]) => (
                  <tr key={day}>
                    <th className="border border-gray-300 px-4 py-2 md:py-4 text-center font-normal sm:w-[100px] w-[70px] text-text ">{day}</th>
                    <td className="border border-gray-300 px-4 py-2 flex flex-wrap">
                      {timeBlocks.length > 0 ? (
                        timeBlocks.map((block, index) => (
                          <span key={index} className="bg-blue-100 text-blue-700 font-medium sm:text-sm text-xs my-1 p-[5px] rounded mr-2">
                            {block.start} - {block.end}
                          </span>
                        ))
                      ) : (
                        <span className="text-subtitle sm:text-base text-sm sm:my-2 my-1 ">Unavailable</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className="bg-background border border-border p-4 md:p-6 rounded-lg shadow-md w-full lg:w-[30%]">
  <div className="flex justify-between items-center mb-4">
    <h2 className="text-lg md:text-xl font-semibold text-subtitle">Horas específicas</h2>
    <button onClick={() => setIsSpecificHoursModalOpen(true)} className="text-blue-500 hover:text-blue-700">
      Editar horas específicas
    </button>
  </div>
  {specificHours.length > 0 ? (
    specificHours.map((specificHour, index) => (
      <div key={index} className="border border-border p-2 my-2 rounded">
        <div className="flex justify-between items-center">
          <p className="font-medium text-text">{formatDate(specificHour.date)}</p>
          <div className="flex gap-2">
            <button
              onClick={() => handleEditSpecificHour(index)}
              className="text-blue-500 hover:text-blue-700"
            >
              <Pencil className="w-5 h-5" />
              
            </button>
            <button
              onClick={() => handleDeleteSpecificHour(index)}
              className="text-red-500 hover:text-red-700"
            >
              <X/>
            </button>
          </div>
        </div>
        <div className="flex flex-wrap">
          {specificHour.timeBlocks.map((block, idx) => (
            <span key={idx} className="bg-blue-100 text-blue-700 font-medium p-1 rounded mr-2 mt-1">
              {block.start} - {block.end}
            </span>
          ))}
        </div>
      </div>
    ))
  ) : (
    <p className="text-gray-500">
      Este horario aún no tiene horas específicas para una fecha.  
      Utilice horarios específicos de fecha para realizar ajustes puntuales a su disponibilidad.
    </p>
  )}
</section>
      </div>

      

      
      <div className=" sm:flex justify-between mt-10 ">
      <section className="bg-background border border-border p-6 rounded-xl shadow-lg mt-6 w-full lg:w-[67%]">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl md:text-2xl font-bold text-subtitle">Horas Estacionales</h2>
          <button 
            onClick={() => setIsSeasonalHoursModalOpen(true)} 
            className="text-blue-600 hover:text-blue-800 font-medium transition-colors"
          >
            Editar Horas
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {seasonalHours.length > 0 ? (
            seasonalHours.map((seasonalHour, index) => (
              <div key={index} className="border border-border p-4 rounded-lg shadow-sm bg-background">
                <p className="text-lg font-semibold text-text">{seasonalHour.seasonName}</p>
                <p className="text-gray-600 sm:text-base text-xs ">{formatDate(seasonalHour.startDate)} - {formatDate(seasonalHour.endDate)}</p>
                <div className="mt-2">
                  {Object.entries(seasonalHour.schedule).map(([day, timeBlocks]) => (
                    <div key={day} className="mb-2">
                      <span className="block text-sm font-medium text-subtitle uppercase">{day}</span>
                      <div className="flex flex-wrap gap-2 mt-1">
                        {timeBlocks.map((block, idx) => (
                          <span key={idx} className="bg-blue-100 text-blue-700 px-2 py-1 rounded-md text-sm font-medium">
                            {block.start} - {block.end}
                          </span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="flex justify-end gap-2 mt-4">
                  <button 
                    onClick={() => handleEditSeason(index)} 
                    className="text-blue-500 hover:text-blue-700"
                  >
                    Editar
                  </button>
                  <button 
                    onClick={() => handleDeleteSeason(index)} 
                    className="text-red-500 hover:text-red-700"
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-center col-span-2">
              Este horario aún no tiene horas estacionales definidas.
            </p>
          )}
        </div>
      </section>

      <section className="border border-border mt-6 sm:w-[30%] shadow rounded p-4">
  <div className="flex justify-between items-center mb-4">
    <p className="text-text font-semibold">Días Específicos Deshabilitados</p>
    <button
      onClick={() => setIsDisabledDaysModalOpen(true)}
      className="text-xs text-red-500 hover:text-red-700"
    >
      Deshabilitar Días Específicos
    </button>
  </div>

  {disabledDays.length > 0 ? (
    <div className="space-y-2">
      {disabledDays.map((date, index) => (
        <div key={index} className="flex justify-between items-center p-2 border border-gray-200 rounded-md">
          <span className="text-text">{formatDate(date)}</span>
          <button
            onClick={() => {
              const updatedDisabledDays = disabledDays.filter((d) => d !== date);
              setDisabledDays(updatedDisabledDays);
            }}
            className="text-red-500 hover:text-red-700"
          >
            <X/>
          </button>
        </div>
      ))}
    </div>
  ) : (
    <p className="text-gray-500 text-sm">
      No hay días deshabilitados.
    </p>
  )}
</section>
      </div>

      <ModalCalendarWeek
  isModalOpen={isModalOpen}
  setIsModalOpen={setIsModalOpen}
  initialSchedule={weeklyHours}
  onSave={handleSave}
  onClose={() => setIsModalOpen(false)}
  disabledDays={disabledDays} 
  errorMessageOverLap={errorMessageOverLap}
/>

<ModalSpecificHours
  isModalOpen={isSpecificHoursModalOpen}
  setIsModalOpen={setIsSpecificHoursModalOpen}
  onSaveSpecificHours={handleSaveSpecificHours}
  disabledDays={disabledDays}
  errorMessage={errorMessage}
  errorMessageOverLap={errorMessageOverLap}
  editingSpecificHour={editingSpecificHourIndex !== null ? specificHours[editingSpecificHourIndex] : null}
  onEditSpecificHour={(date, timeBlocks) => {
    const updatedSpecificHours = [...specificHours];
    updatedSpecificHours[editingSpecificHourIndex] = { date, timeBlocks };
    setSpecificHours(updatedSpecificHours);
    setEditingSpecificHourIndex(null);
  }}
/>

<ModalSeasonalHours
  isModalOpen={isSeasonalHoursModalOpen}
  setIsModalOpen={setIsSeasonalHoursModalOpen}
  onSaveSeasonalHours={handleSaveSeasonalHours}
  editingSeason={editingSeasonIndex !== null ? seasonalHours[editingSeasonIndex] : null}
  disabledDays={disabledDays}
  errorMessage={errorMessage}
  errorMessageOverLap={errorMessageOverLap} 
/>

      <ModalDisabledDays
        isModalOpen={isDisabledDaysModalOpen}
        setIsModalOpen={setIsDisabledDaysModalOpen}
        onSaveDisabledDays={handleSaveDisabledDays}
      />
    </div>
  );
}